/**
 * Patterns that match identifiers only. Route names such as
 * "neighborhood-management" or "geographies" have to fall through untouched,
 * which is why the catch-all token pattern requires a digit and rejects word
 * separators.
 */
const VOLATILE_PATH_SEGMENT_PATTERNS = [
  // Numeric IDs.
  /^\d+$/,
  // UUIDs.
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
  // Local Logic geography and POI IDs, e.g. g30_dxbz2b1v.
  /^g\d+_[a-z0-9]+$/i,
  // A `lng,lat` coordinate, or a `;`-separated waypoint list of them.
  /^-?\d+(?:\.\d+)?,-?\d+(?:\.\d+)?(?:;-?\d+(?:\.\d+)?,-?\d+(?:\.\d+)?)*$/,
  // Long opaque tokens: client IDs, hashes, encoded coordinates.
  /^(?=.*\d)[a-z0-9_]{12,}$/i,
];

/**
 * Whether a URL path segment is a value rather than a route name.
 *
 * Used to mask identifiers out of a path before it becomes a grouping key, so
 * one endpoint doesn't produce a separate issue per ID.
 */
export const isVolatilePathSegment = (segment: string): boolean =>
  VOLATILE_PATH_SEGMENT_PATTERNS.some((pattern) => pattern.test(segment));
